import { AxiosInstance } from 'axios';
import {
  BillsTotalRepository,
  BillsTotalRequest,
  BillsTotalResponse,
} from '@/model/repository/manager/bill/BillsTotalRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): BillsTotalRepository => ({
    get(payload: BillsTotalRequest): BillsTotalResponse {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
